<button type="button" class="btn btn-info mx-2 custom-size-button" (click)="showDialog = true">
  {{ "case.payment-informations.digital-payment.sms-dialog" | translate }}
</button>
<button type="button" class="btn btn-info custom-size-button" (click)="openPaymentInDialog()">
  {{ "case.payment-informations.digital-payment.goto-payment" | translate }}
</button>

<p-dialog
  [(visible)]="showDialog"
  appendTo="body"
  [style]="{ width: '40vw' }"
  [maximizable]="false"
  [header]="'case.payment-informations.digital-payment.sms-dialog' | translate"
  modal="true"
>
	<div class="modal-body">
    <div class="form-group">
      <label for="">{{ "case.sms.template" | translate }}</label>
      <p-dropdown
        [options]="filteredTemplates"
        [(ngModel)]="selectedTemplate"
        [filter]="true"
        [placeholder]="'case.sms.template-placeholder' | translate"
		(ngModelChange)="onTemplateChange($event)"
        optionLabel="templateName"
		[disabled]="true"
      >
      </p-dropdown>
    </div>

    <div class="form-group">
      <label for="">{{ "case.sms.phone" | translate }}</label>
      <div class="phone-chips" *ngIf="this.selectedTemplate">
        <div
          *ngFor="let phone of availablePhones"
          class="phone-chip mb-2"
          [class.selected]="isPhoneSelected(phone)"
          (click)="togglePhone(phone)" role="button"  tabindex="-1"
        >
          {{ phone }}
        </div>
      </div>

      <p-chips
        [allowDuplicate]="false"
        [(ngModel)]="selectedPhones"
        (onAdd)="handleChipAdd($event)"
      />
    </div>

    <div class="form-group">
      <label for="">{{ "case.sms.content" | translate }}</label>
      <app-readonly-input
        [type]="'textarea'"
        [value]="selectedContent"
      ></app-readonly-input>
    </div>
  </div>

<ng-template pTemplate="footer">
	<div class="dialog-footer">
      <button 
        type="button"
        class="send-button"
        (click)="sendSms()">
        Gönder
      </button>
    </div>
</ng-template>

</p-dialog>

<p-dialog
  [(visible)]="showPayment"
  appendTo="body"
  [style]="{ 'max-width': '660px', 'min-height': '98vh' }"
  [maximizable]="false"
  modal="true"
>
  <iframe [src]="paymentUrl" style="height: 100vh; width: 500px; border: none;" title=""></iframe>
</p-dialog>